// extracted by mini-css-extract-plugin
module.exports = {"sectionColumns":"AllModules_sectionColumns__61fL2","blink":"AllModules_blink__mgfVf"};